export default {
      id: "dateAsc-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#dateAsc",
      toString: function () {
        return this.url;
      }
    }